<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>

export default {
    name: "App",
   
};
</script>

<style>
body {
    background: #eff0f5;
}
.pages {
    min-height: 100vh;
    background-color: #fff;
}
/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 5px;
  background-color: #fff;
  border-radius: 8px;
}

::-webkit-scrollbar-thumb {
  width: 5%;
  background-color: #e5e5e5;
  border-radius: 8px;
}

::-webkit-resizer {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px soild #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue